import { AIStatusBadge, Card, Header, Space, Text } from '@procurify/ui'

import { Tabs } from '@webapp/core/components/Tabs'
import { useProcurifyIntl } from '@webapp/hooks'
import { FeatureShowcase } from '@webapp/platform/discover-more/components/FeatureShowcase'
import { ChangelogReleaseListPresenter } from '@webapp/platform/discover-more/features/list-changelog-releases/presenters/ChangelogReleaseListPresenter'
import messages from './messages'
import { DiscoverMoreViewStyled } from './styles/DiscoverMoreViewStyled'
import { useDiscoverMoreView } from './useDiscoverMoreView'

export const DiscoverMoreView = () => {
  const intl = useProcurifyIntl()

  const {
    data: {
      featureContent,
      urls: {
        whatsNewUrl,
        guidedIntakeUrl,
        apUrl,
        contractsUrl,
        customFieldsUrl,
      },
    },
    states: { isWhatsNewTab, isButtonDisabled },
    commands: { onDemoRequested, onDemoRequestFailed, onTourClicked },
  } = useDiscoverMoreView()

  return (
    <DiscoverMoreViewStyled>
      <Space size='small'>
        <Header as='h1'>{intl.formatMessage(messages.heading)}</Header>

        <Text>{intl.formatMessage(messages.framingLine)}</Text>

        <Tabs>
          <Tabs.TabLink key='whats-new' to={whatsNewUrl}>
            {intl.formatMessage(messages.whatsNewTabLabel)}
          </Tabs.TabLink>
          <Tabs.TabLink key='guided-intake' to={guidedIntakeUrl}>
            <Space direction='horizontal' size='small' align='center'>
              <>{intl.formatMessage(messages.guidedIntakeTabLabel)}</>
              <AIStatusBadge text={intl.formatMessage(messages.aiLabel)} />
            </Space>
          </Tabs.TabLink>
          <Tabs.TabLink key='ap' to={apUrl}>
            <Space direction='horizontal' size='small' align='center'>
              <>{intl.formatMessage(messages.apTabLabel)}</>
              <AIStatusBadge text={intl.formatMessage(messages.aiLabel)} />
            </Space>
          </Tabs.TabLink>
          <Tabs.TabLink key='contracts' to={contractsUrl}>
            <Space direction='horizontal' size='small' align='center'>
              <>{intl.formatMessage(messages.contractsTabLabel)}</>
              <AIStatusBadge text={intl.formatMessage(messages.aiLabel)} />
            </Space>
          </Tabs.TabLink>
          <Tabs.TabLink key='custom-fields' to={customFieldsUrl}>
            {intl.formatMessage(messages.customFieldsTabLabel)}
          </Tabs.TabLink>
        </Tabs>
      </Space>

      {isWhatsNewTab ? (
        <ChangelogReleaseListPresenter />
      ) : (
        <Card>
          <Card.Content>
            {featureContent && (
              <FeatureShowcase
                {...featureContent}
                onDemoRequested={onDemoRequested}
                onDemoRequestFailed={onDemoRequestFailed}
                onTourClicked={onTourClicked}
                isButtonDisabled={isButtonDisabled}
              />
            )}
          </Card.Content>
        </Card>
      )}
    </DiscoverMoreViewStyled>
  )
}

DiscoverMoreView.displayName = 'DiscoverMoreView'
